/**
* A polyfill for Array.isArray
*/
if (!Array.isArray)
{
    Array.isArray = function (arg)
    {
        return Object.prototype.toString.call(arg) === '[object Array]';
    };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/phaser/src/polyfills/Array.isArray.js
// module id = 434
// module chunks = 0